import {
  FETCH_CSR_AGENT,
  FETCH_CSR_AGENT_START,
  FETCH_CSR_AGENT_END,
  FETCH_CSR_AGENT_ERROR,
  REMOVE_CSR_AGENT,
  CLEAR_ERROR,
} from '../actions/types';

const initialState = {
  isLoading: null,
  agents: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_CSR_AGENT_START:
      return { ...initialState, isLoading: true };
    case FETCH_CSR_AGENT:
      return { ...state, agents: action.payload };
    case FETCH_CSR_AGENT_END:
      return { ...state, isLoading: false };
    case FETCH_CSR_AGENT_ERROR:
      return { error: action.payload };
    case REMOVE_CSR_AGENT:
      return { ...initialState, agents: [] };
    case CLEAR_ERROR:
      return { ...initialState, agents: state.agents };
    default:
      return state;
  }
}
